// removed by extract-text-webpack-plugin
module.exports = {"Container3x3":"src-HOC-Layout-__PageContainer-module___Container3x3","Container2x3":"src-HOC-Layout-__PageContainer-module___Container2x3","Main":"src-HOC-Layout-__PageContainer-module___Main","Title":"src-HOC-Layout-__PageContainer-module___Title","Button":"src-HOC-Layout-__PageContainer-module___Button"};


//////////////////
// WEBPACK FOOTER
// ./src/HOC/Layout/PageContainer.module.css
// module id = 1168
// module chunks = 1